import { CallAPI } from "../../apiManager/ApiCall";
import {
  quizProfessorTitlesURL,
  quizQuestionBankURL,
  quizAssignmentsURL,
  quizAssignedURL,
  quizAttemptsStartURL,
  quizAttemptsStartByCodeURL,
  quizAttemptsSubmitURL,
  quizAttemptsMyURL,
  quizAttemptsResultURL,
  quizByTileURL,
  quizBySlideURL,
  quizLinkedIdsURL,
  quizHeatmapURL,
  quizResultsURL,
  aiQuizInsightsURL,
} from "../../apiManager/APIConfig";

const base = (path, method = "GET", body = null) =>
  CallAPI({ url: path, method, body });

// Professor titles (for question bank & quiz topics)
export const listProfessorTitlesCall = (params = {}) => {
  const q = new URLSearchParams(params).toString();
  return base(q ? `${quizProfessorTitlesURL}?${q}` : quizProfessorTitlesURL, "GET");
};
export const createProfessorTitleCall = (body) => base(quizProfessorTitlesURL, "POST", body);
export const updateProfessorTitleCall = (id, body) => base(`${quizProfessorTitlesURL}/${id}`, "PUT", body);
export const deleteProfessorTitleCall = (id, params = {}) => {
  const q = new URLSearchParams(params).toString();
  return base(
    q ? `${quizProfessorTitlesURL}/${id}?${q}` : `${quizProfessorTitlesURL}/${id}`,
    "DELETE"
  );
};

// Question bank
export const createQuestionCall = (body) =>
  base(quizQuestionBankURL, "POST", body);
export const updateQuestionCall = (id, body) =>
  base(`${quizQuestionBankURL}/${id}`, "PUT", body);
export const deleteQuestionCall = (id) =>
  base(`${quizQuestionBankURL}/${id}`, "DELETE");
export const listQuestionsCall = (params = {}) => {
  const q = new URLSearchParams(params).toString();
  return base(q ? `${quizQuestionBankURL}?${q}` : quizQuestionBankURL, "GET");
};
export const listMicrolabQuestionsCall = (catalogue = "histology") =>
  base(`quiz/microlab-question-bank?catalogue=${encodeURIComponent(catalogue)}`, "GET");
export const listMicrolabTitleOptionsCall = (catalogue = "histology", lang = "en") => {
  const params = new URLSearchParams({
    catalogue: String(catalogue || "histology"),
    lang: String(lang || "en"),
  });
  return base(`quiz/microlab-title-options?${params.toString()}`, "GET");
};

// Quiz assignments
/** Dry-run pick of bank questions (private or Microlab) before release. */
export const previewAssignmentQuestionsCall = (body) =>
  base(`${quizAssignmentsURL}/preview-questions`, "POST", body);
/** Hydrated questions pinned on an existing quiz assignment. */
export const getAssignmentLockedQuestionsCall = (id) =>
  base(`${quizAssignmentsURL}/${id}/locked-questions`, "GET");
export const createQuizAssignmentCall = (body) =>
  base(quizAssignmentsURL, "POST", body);
export const updateQuizAssignmentCall = (id, body) =>
  base(`${quizAssignmentsURL}/${id}`, "PUT", body);
export const deleteQuizAssignmentCall = (id) =>
  base(`${quizAssignmentsURL}/${id}`, "DELETE");
export const listQuizAssignmentsCall = (params = {}) => {
  const q = new URLSearchParams(params).toString();
  return base(q ? `${quizAssignmentsURL}?${q}` : quizAssignmentsURL, "GET");
};

// Student: assigned quizzes
export const listAssignedQuizzesCall = () =>
  base(quizAssignedURL, "GET");

// Attempts
export const startAttemptCall = (quiz_assignment_id) =>
  base(quizAttemptsStartURL, "POST", { quiz_assignment_id });
export const startAttemptByCodeCall = (access_code) =>
  base(quizAttemptsStartByCodeURL, "POST", { access_code });
export const getAttemptCall = (attempt_id) =>
  base(`quiz/attempts/${attempt_id}`, "GET");
export const submitAttemptCall = (attempt_id, answers) =>
  base(quizAttemptsSubmitURL, "POST", { attempt_id, answers });
export const getAttemptResultCall = (attempt_id) =>
  base(`${quizAttemptsResultURL}?attempt_id=${attempt_id}`, "GET");
export const listMyAttemptsCall = () =>
  base(quizAttemptsMyURL, "GET");

// By tile / slide (for indicators)
export const getQuizzesByTileCall = (tile_id) =>
  base(`${quizByTileURL}?tile_id=${tile_id}`, "GET");
export const getQuizzesBySlideCall = (params) => {
  const q = new URLSearchParams(params).toString();
  return base(`${quizBySlideURL}?${q}`, "GET");
};

export const getQuizLinkedIdsCall = (params = {}) => {
  const q = new URLSearchParams(params).toString();
  return base(q ? `${quizLinkedIdsURL}?${q}` : quizLinkedIdsURL, "GET");
};
export const getQuizHeatmapCall = (params = {}) => {
  const q = new URLSearchParams(params).toString();
  return base(q ? `${quizHeatmapURL}?${q}` : quizHeatmapURL, "GET");
};
export const getQuizResultsCall = (params = {}) => {
  const q = new URLSearchParams(params).toString();
  return base(q ? `${quizResultsURL}?${q}` : quizResultsURL, "GET");
};
export const getStudentQuizProgressCall = (userId) =>
  base(`${quizResultsURL}/student/${userId}`, "GET");

// Quiz Insights (AI analysis, on-demand, deletable)
export const listQuizInsightsCall = (params = {}) => {
  const q = new URLSearchParams(params).toString();
  return base(q ? `${aiQuizInsightsURL}?${q}` : aiQuizInsightsURL, "GET");
};
export const createQuizInsightCall = (body) =>
  base(aiQuizInsightsURL, "POST", body);
export const deleteQuizInsightCall = (id) =>
  base(`${aiQuizInsightsURL}/${id}`, "DELETE");
